// Default dashboard configurations for each role
export const defaultDashboardConfigs = {
  hod: {
    widgets: [
      { id: 'stats-overview', enabled: true, order: 1, size: 'full' },
      { id: 'student-search', enabled: true, order: 2, size: 'full' },
      { id: 'faculty-roles', enabled: true, order: 3, size: 'full' },
      { id: 'student-management', enabled: true, order: 4, size: 'full' },
      { id: 'semester-subjects', enabled: true, order: 5, size: 'full' },
      { id: 'divisionassignments', enabled: true, order: 6, size: 'full' },
      { id: 'system-archive', enabled: true, order: 7, size: 'full' },
      { id: 'submission-status-report', enabled: true, order: 8, size: 'full' },
      { id: 'staff-management', enabled: true, order: 9, size: 'full' },
      { id: 'analytics-charts', enabled: true, order: 10, size: 'full' },
      { id: 'achievement-approvals', enabled: true, order: 11, size: 'half' },
      { id: 'leave-approvals', enabled: true, order: 12, size: 'half' },
      { id: 'messaging', enabled: true, order: 13, size: 'full' },
      { id: 'sheets-sync', enabled: true, order: 14, size: 'full' },
      { id: 'studentlist', enabled: true, order: 15, size: 'full' },  
    ],
    permissions: {
      canAddStaff: true,
      canEditStaff: true,
      canDeleteStaff: true,
      canAssignMentors: true,
      canConfigureDashboards: true,
      canSyncSheets: true,
      canViewAllStudents: true,
      canViewAllStaff: true,
      canSendMessages: true,
      canApproveLeaves: true,
      canApproveAchievements: true,
      canGenerateReports: true,
      canEditStudentProfiles: true,
      canDeleteStudentPhotos: true,
    }
  },
  
  mentoringCoordinator: {
    widgets: [
      { id: 'stats-overview', enabled: true, order: 1, size: 'full' },
      { id: 'batch-assignments', enabled: true, order: 2, size: 'full' },
      { id: 'student-search', enabled: true, order: 3, size: 'full' },
      { id: 'mentor-overview', enabled: true, order: 4, size: 'full' },
      { id: 'unassigned-students', enabled: true, order: 5, size: 'half' },
      { id: 'analytics-charts', enabled: true, order: 6, size: 'half' },
      { id: 'submission-status-report', enabled: true, order: 7, size: 'full' },
      { id: 'messaging', enabled: true, order: 8, size: 'full' },
      { id: 'studentlist', enabled: true, order: 9, size: 'full' },  
    ],
    permissions: {
      canAddStaff: false,
      canEditStaff: false,
      canDeleteStaff: false,
      canAssignMentors: true,
      canConfigureDashboards: false,
      canSyncSheets: false,
      canViewAllStudents: true,
      canViewAllStaff: true,
      canSendMessages: true,
      canApproveLeaves: false,
      canApproveAchievements: false,
      canGenerateReports: true,
      canEditStudentProfiles: false,
      canDeleteStudentPhotos: false,
    }
  },
  
  classCoordinator: {
    widgets: [
      { id: 'stats-overview', enabled: true, order: 1, size: 'full' },
      { id: 'student-search', enabled: true, order: 2, size: 'full' },
      { id: 'attendance-entry', enabled: true, order: 3, size: 'full' },
      { id: 'leave-approvals', enabled: true, order: 4, size: 'full' },
      { id: 'division-analytics', enabled: true, order: 5, size: 'full' },
      { id: 'submission-status-report', enabled: true, order: 6, size: 'full' },
      { id: 'messaging', enabled: true, order: 7, size: 'full' },
      { id: 'studentlist', enabled: true, order: 8, size: 'full' },  
    ],
    permissions: {
      canAddStaff: false,
      canEditStaff: false,
      canDeleteStaff: false,
      canAssignMentors: false,
      canConfigureDashboards: false,
      canSyncSheets: false,
      canViewAllStudents: false,
      canViewAllStaff: false,
      canSendMessages: true,
      canApproveLeaves: true,
      canApproveAchievements: false,
      canGenerateReports: true,
      canEditStudentProfiles: false,
      canDeleteStudentPhotos: false,
    }
  },
  
  mentor: {
    widgets: [
      { id: 'mentee-list', enabled: true, order: 1, size: 'full' },
      { id: 'mentee-details', enabled: true, order: 2, size: 'full' },
      { id: 'pendingachievements', enabled: true, order: 3, size: 'full' },
      { id: 'achievement-approvals', enabled: true, order: 4, size: 'full' },
      { id: 'attendance-alerts', enabled: true, order: 5, size: 'full' },
      { id: 'parents-meet-management', enabled: true, order: 6, size: 'full' },
      { id: 'submission-status-report', enabled: true, order: 7, size: 'full' },
      { id: 'messaging', enabled: true, order: 8, size: 'full' },
      { id: 'mentee-yaadi', enabled: true, order: 9, size: 'full' },
      
    ],
    permissions: {
      canAddStaff: false,
      canEditStaff: false,
      canDeleteStaff: false,
      canAssignMentors: false,
      canConfigureDashboards: false,
      canSyncSheets: false,
      canViewAllStudents: false,
      canViewAllStaff: false,
      canSendMessages: true,
      canApproveLeaves: false,
      canApproveAchievements: true,
      canGenerateReports: true,
      canEditStudentProfiles: false,
      canDeleteStudentPhotos: false,
    }
  },

  faculty: {
    widgets: [
      { id: 'faculty-profile', enabled: true, order: 1, size: 'full' }
    ],
    permissions: {
      canAddStaff: false,
      canEditStaff: false,
      canDeleteStaff: false,
      canAssignMentors: false,
      canConfigureDashboards: false,
      canSyncSheets: false,
      canViewAllStudents: false,
      canViewAllStaff: false,
      canSendMessages: false,
      canApproveLeaves: false,
      canApproveAchievements: false,
      canGenerateReports: false,
      canEditStudentProfiles: false,
      canDeleteStudentPhotos: false,
    }
  },

  courseIncharge: {
    widgets: [
      { id: 'faculty-profile', enabled: true, order: 1, size: 'full' },
      { id: 'course-marks-entry', enabled: true, order: 2, size: 'full' },
      { id: 'course-attendance-entry', enabled: true, order: 3, size: 'full' }
    ],
    permissions: {
      canAddStaff: false,
      canEditStaff: false,
      canDeleteStaff: false,
      canAssignMentors: false,
      canConfigureDashboards: false,
      canSyncSheets: false,
      canViewAllStudents: false,
      canViewAllStaff: false,
      canSendMessages: false,
      canApproveLeaves: false,
      canApproveAchievements: false,
      canGenerateReports: true,
      canEditStudentProfiles: false,
      canDeleteStudentPhotos: false,
    }
  },
  
  student: {
    widgets: [
      { id: 'student-profile', enabled: true, order: 1, size: 'full' },
      { id: 'attendance-card', enabled: true, order: 2, size: 'third' },
      { id: 'ia-test1-card', enabled: true, order: 3, size: 'third' },
      { id: 'ia-test2-card', enabled: true, order: 4, size: 'third' },
      { id: 'quick-actions', enabled: true, order: 5, size: 'full' },
      { id: 'achievements-list', enabled: true, order: 6, size: 'full' },
      { id: 'leaderboard', enabled: true, order: 7, size: 'half' },
      { id: 'notifications', enabled: true, order: 8, size: 'half' },
      { id: 'student-id-card', enabled: true, order: 9, size: 'third' },
    ],
    permissions: {
      canAddStaff: false,
      canEditStaff: false,
      canDeleteStaff: false,
      canAssignMentors: false,
      canConfigureDashboards: false,
      canSyncSheets: false,
      canViewAllStudents: false,
      canViewAllStaff: false,
      canSendMessages: false,
      canApproveLeaves: false,
      canApproveAchievements: false,
      canGenerateReports: false,
      canEditStudentProfiles: true,
      canDeleteStudentPhotos: false,
    }
  },
  
  administrator: {
    widgets: [
      { id: 'stats-overview', enabled: true, order: 1, size: 'full' },
      { id: 'student-search', enabled: true, order: 2, size: 'full' },
      { id: 'staff-management', enabled: true, order: 3, size: 'full' },
      { id: 'analytics-charts', enabled: true, order: 4, size: 'full' },
      { id: 'achievement-approvals', enabled: true, order: 5, size: 'half' },
      { id: 'leave-approvals', enabled: true, order: 6, size: 'half' },
      { id: 'messaging', enabled: true, order: 7, size: 'full' },
      { id: 'sheets-sync', enabled: true, order: 8, size: 'full' },
    ],
    permissions: {
      canAddStaff: true,
      canEditStaff: true,
      canDeleteStaff: true,
      canAssignMentors: true,
      canConfigureDashboards: true,
      canSyncSheets: true,
      canViewAllStudents: true,
      canViewAllStaff: true,
      canSendMessages: true,
      canApproveLeaves: true,
      canApproveAchievements: true,
      canGenerateReports: true,
      canEditStudentProfiles: true,
      canDeleteStudentPhotos: true,
      canCreateWidgets: true,
      canDeleteWidgets: true,
    }
  }
};

// Widget metadata
export const widgetLibrary = {
  'stats-overview': {
    name: 'Statistics Overview',
    description: 'Overall system statistics',
    category: 'analytics',
    availableFor: ['hod', 'mentoringCoordinator', 'classCoordinator']
  },
  'student-search': {
    name: 'Student Search',
    description: 'Search and view student details',
    category: 'search',
    availableFor: ['hod', 'mentoringCoordinator', 'classCoordinator']
  },
  'student-id-card': {
  name: 'Student ID Card',
  description: 'ID card style profile',
  category: 'profile',
  availableFor: ['student']
},
  'staff-management': {
    name: 'Staff Management',
    description: 'Add, edit, delete staff',
    category: 'admin',
    availableFor: ['hod']
  },
  'faculty-roles': {
    name: 'Faculty Management',
    description: 'Add faculty and assign dashboard duties',
    category: 'admin',
    availableFor: ['hod']
  },
  'faculty-profile': {
    name: 'My Faculty Profile',
    description: 'Edit faculty profile and photo',
    category: 'profile',
    availableFor: ['faculty', 'classCoordinator', 'mentoringCoordinator', 'mentor', 'courseIncharge']
  },
  'system-archive': {
    name: 'Backup, Reset & Annual Analysis',
    description: 'Export/restore data and review annual reports',
    category: 'admin',
    availableFor: ['hod']
  },
  'student-management': {
    name: 'Student Management',
    description: 'Add students, import sheets, and assign student offices',
    category: 'admin',
    availableFor: ['hod']
  },
  'semester-subjects': {
    name: 'Semester Subject Management',
    description: 'Define Semester 1 and 2 subjects for student reports',
    category: 'academics',
    availableFor: ['hod']
  },
  'analytics-charts': {
    name: 'Analytics Charts',
    description: 'Visual analytics and graphs',
    category: 'analytics',
    availableFor: ['hod', 'mentoringCoordinator']
  },
  'achievement-approvals': {
    name: 'Achievement Approvals',
    description: 'Approve/reject student achievements',
    category: 'approvals',
    availableFor: ['hod', 'mentor']
  },
  'leave-approvals': {
    name: 'Leave Approvals',
    description: 'Approve/reject leave requests',
    category: 'approvals',
    availableFor: ['hod', 'classCoordinator']
  },
  'attendance-entry': {
    name: 'Attendance Entry',
    description: 'Enter monthly attendance by student',
    category: 'academics',
    availableFor: ['classCoordinator']
  },
  'course-marks-entry': {
    name: 'Course Marks Entry',
    description: 'Enter IAT-1, IAT-2, ESE marks and remarks for assigned subjects',
    category: 'academics',
    availableFor: ['courseIncharge']
  },
  'course-attendance-entry': {
    name: 'Course Attendance Entry',
    description: 'Enter month-wise subject attendance for assigned course divisions',
    category: 'academics',
    availableFor: ['courseIncharge']
  },
  'submission-status-report': {
    name: 'Submission Status Reports',
    description: 'Monitor month-wise attendance and IAT marks completion against HOD deadlines',
    category: 'academics',
    availableFor: ['hod', 'mentoringCoordinator', 'classCoordinator', 'mentor']
  },
  'messaging': {
    name: 'Messaging',
    description: 'Send messages to users',
    category: 'communication',
    availableFor: ['hod', 'mentoringCoordinator', 'classCoordinator', 'mentor']
  },
  'sheets-sync': {
    name: 'Google Sheets Sync',
    description: 'Sync data with Google Sheets',
    category: 'admin',
    availableFor: ['hod']
  },
  'batch-assignments': {
    name: 'Batch Management',
    description: 'Create batches and assign mentors',
    category: 'assignments',
    availableFor: ['mentoringCoordinator', 'hod']
  },
  'mentor-overview': {
    name: 'Mentor Overview',
    description: 'View all mentors and assignments',
    category: 'overview',
    availableFor: ['mentoringCoordinator']
  },
  'unassigned-students': {
    name: 'Unassigned Students',
    description: 'Students without batch assignments',
    category: 'assignments',
    availableFor: ['mentoringCoordinator']
  },
  'division-analytics': {
    name: 'Division Analytics',
    description: 'Analytics for specific division',
    category: 'analytics',
    availableFor: ['classCoordinator']
  },
  'mentee-list': {
    name: 'Mentee List',
    description: 'List of assigned mentees',
    category: 'mentoring',
    availableFor: ['mentor']
  },
  'mentee-details': {
    name: 'Mentee Details',
    description: 'Detailed view of selected mentee',
    category: 'mentoring',
    availableFor: ['mentor']
  },
  'attendance-alerts': {
    name: 'Attendance Alerts',
    description: 'Low attendance warnings',
    category: 'alerts',
    availableFor: ['mentor']
  },
  'parents-meet-management': {
    name: 'Parents Meet Management',
    description: 'Record parent interactions for mentees',
    category: 'mentoring',
    availableFor: ['mentor']
  },
  'student-profile': {
    name: 'Student Profile',
    description: 'Student profile information',
    category: 'profile',
    availableFor: ['student']
  },
  'attendance-card': {
    name: 'Attendance Card',
    description: 'Attendance summary',
    category: 'academics',
    availableFor: ['student']
  },
  'ia-test1-card': {
    name: 'IA Test 1 Card',
    description: 'IA Test 1 results',
    category: 'academics',
    availableFor: ['student']
  },
  'ia-test2-card': {
    name: 'IA Test 2 Card',
    description: 'IA Test 2 results',
    category: 'academics',
    availableFor: ['student']
  },
  'quick-actions': {
    name: 'Quick Actions',
    description: 'Quick action buttons',
    category: 'actions',
    availableFor: ['student']
  },
  'achievements-list': {
    name: 'Achievements List',
    description: 'Student achievements',
    category: 'achievements',
    availableFor: ['student']
  },
  'leaderboard': {
    name: 'Leaderboard',
    description: 'Top performers',
    category: 'engagement',
    availableFor: ['student']
  },
  'notifications': {
    name: 'Notifications',
    description: 'User notifications',
    category: 'communication',
    availableFor: ['student']
  },
  'widget-maker': {
    name: 'Widget Maker',
    description: 'Create custom widgets with AI - Administrator Only',
    category: 'admin',
    availableFor: ['administrator']
  },

  // CUSTOM WIDGETS
  'noticesandannouncements': {
    name: 'NoticesAndAnnouncements',
    description: 'Custom AI-generated widget',
    category: 'custom',
    availableFor: ["hod","student","mentor","classCoordinator","mentoringCoordinator"]
  },
  'warningletters': {
    name: 'WarningLetters',
    description: 'Custom AI-generated widget',
    category: 'custom',
    availableFor: ["hod","classCoordinator"]
  },
  'forminfo': {
    name: 'Forminfo',
    description: 'Custom AI-generated widget',
    category: 'custom',
    availableFor: ["student","classCoordinator","mentor"]
  },
  'divisionassignments': {
    name: 'Division Management',
    description: 'Create divisions and assign coordinators',
    category: 'custom',
    availableFor: ["hod"]
  },

  'pendingachievements': {
    name: 'PendingAchievements',
    description: 'Custom AI-generated widget',
    category: 'custom',
    availableFor: ["hod","mentor"]
  },
  'attendancereport': {
    name: 'AttendanceReport',
    description: 'Custom AI-generated widget',
    category: 'custom',
    availableFor: ["hod","mentoringCoordinator","classCoordinator","mentor","student"]
  },

  'topperformers': {
    name: 'Topperformers',
    description: 'Custom AI-generated widget',
    category: 'custom',
    availableFor: ["hod","mentoringCoordinator","classCoordinator","mentor","student"]
  },
  'slowaveragefastlearners': {
    name: 'SlowAverageFastLearners',
    description: 'Custom AI-generated widget',
    category: 'custom',
    availableFor: ["hod","mentoringCoordinator","student"]
  },
  'nanomessaging': {
    name: 'NanoMessaging',
    description: 'Custom AI-generated widget',
    category: 'custom',
    availableFor: ["hod","mentoringCoordinator","classCoordinator","mentor","student"]
  },
studentlist: {
    name: 'Student List',
    description: 'Division-wise student list with complete details',
    category: 'students',
    availableFor: ['hod', 'mentoringCoordinator', 'classCoordinator', 'mentor']
  },
'mentee-yaadi': {
    name: 'Mentee List',
    description: 'Mentor-wise mentees',
    category: 'custom',
    availableFor: ['mentor']
  },


};
